const policy = [
    {
        name: "Free ship",
        description: "Free shipping with orders > 239K",
        icon: "bx bx-shopping-bag"
    },
    {
        name: "COD payment",
        description: "Payment on delivery (COD)",
        icon: "bx bx-credit-card"
    },
    {
        name: "VIP customers",
        description: "Offers for VIP customers order",
        icon: "bx bx-diamond"
    },
    {
        name: "Warranty support",
        description: "Change and fix things at all stores",
        icon: "bx bx-donate-heart"
    }
]

export default policy